module.exports = __webpack_public_path__ + "img/10.1f365952.png";